import { Link } from "react-router-dom";
import { ArrowRight, ExternalLink, Newspaper } from "lucide-react";

/**
 * Card singola "News" usata sia nella Home che nella pagina /news.
 * Supporta image_fit ("cover"|"contain") e CTA esterna opzionale.
 */
export const NewsCard = ({ news, showEyebrow = false, testidPrefix = "news-card" }) => {
  const hasCta = Boolean(news.cta_label && news.cta_url);
  const isExternalCta = hasCta && /^https?:/.test(news.cta_url);
  const detailUrl = `/news/${news.slug}`;
  const fit = news.image_fit === "contain" ? "object-contain p-6 bg-white" : "object-cover";

  return (
    <article
      data-testid={`${testidPrefix}-${news.slug}`}
      className="group relative flex flex-col bg-white border-2 border-[#E5E1D8] hover:border-[#2E4F3B] rounded-2xl overflow-hidden transition-all hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(0,0,0,0.08)]"
    >
      {news.image_url && (
        <Link to={detailUrl} className="block aspect-[16/10] overflow-hidden bg-[#FBF9F6] relative">
          <img
            src={news.image_url}
            alt={news.title}
            className={`w-full h-full transition-transform duration-500 group-hover:scale-105 ${fit}`}
          />
        </Link>
      )}
      <div className="p-6 flex-1 flex flex-col">
        {showEyebrow && (
          <div className="flex items-center gap-2 mb-3 text-[10px] font-bold uppercase tracking-[0.18em] text-[#C15C3D]">
            <Newspaper className="w-3 h-3" />
            Notizia
          </div>
        )}
        <Link to={detailUrl}>
          <h3 className="font-display text-lg sm:text-xl font-black text-[#1A1A1A] leading-tight mb-3 group-hover:text-[#2E4F3B] transition-colors">
            {news.title}
          </h3>
        </Link>
        <p className="text-sm text-[#5C5C5C] leading-relaxed flex-1 line-clamp-3">{news.excerpt}</p>

        <div className="mt-5 flex flex-col gap-2.5">
          {hasCta && (
            <a
              href={news.cta_url}
              target={isExternalCta ? "_blank" : undefined}
              rel={isExternalCta ? "noopener noreferrer" : undefined}
              data-testid={`${testidPrefix}-cta-${news.slug}`}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-[#C15C3D] hover:bg-[#a64830] text-white font-bold text-sm px-5 py-3 transition-all shadow-md"
            >
              {news.cta_label}
              {isExternalCta ? <ExternalLink className="w-4 h-4" /> : <ArrowRight className="w-4 h-4" />}
            </a>
          )}
          <Link
            to={detailUrl}
            data-testid={`${testidPrefix}-read-${news.slug}`}
            className="inline-flex items-center gap-2 text-sm font-bold text-[#2E4F3B] hover:gap-3 transition-all self-start"
          >
            Leggi tutto
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </article>
  );
};
